
import { AgeTagType, FontItem, SurveyCsvData } from "@/store/types";
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";

import router from "@/router";

const SurveyModule = namespace("survey");
const SystemModule = namespace("system");
@Options({
  components: {},
  beforeRouteEnter: (to, from, next) => {
    if (
      from.fullPath !== "/survey/which-font/20" &&
      from.fullPath !== "/survey/which-font/21" &&
      from.fullPath !== "/survey/what-gender"
    ) {
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
  beforeRouteLeave: (to, from, next) => {
    if (to.fullPath === "/survey/what-gender") {
      next();
    } else if (to.fullPath === "/survey/entrance") {
      next();
    } else if (to.fullPath === "/survey/which-font") {
      /* モーダルを表示する？ */
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
})
export default class SurveyCourtyard extends Vue {
  @SystemModule.Getter("getFontList")
  private getFontList!: FontItem[];

  @SurveyModule.Getter("byAgeTag")
  private byAgeTag!: AgeTagType;

  @SurveyModule.Getter("surveyData")
  private surveyData!: SurveyCsvData;

  @SurveyModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  @SurveyModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  public isVisible = false;

  public async mounted() {
    await this.updateIsWhiteout(false);
    window.scrollTo({ top: 0 });
    this.isVisible = true;
  }

  public async nextPage() {
    await this.updateIsWhiteout(true);
    this.$router.push("/survey/what-gender");
  }

  public get isHiraganaWord() {
    return this.byAgeTag === "UNDER_10";
  }

  public get subtitleWord1() {
    let word =
      "先ほどあなたが選んだフォント（文字）が、これから画面に使われます。";
    if (this.isHiraganaWord) {
      word =
        "いま あなたが えらんだ もじが、 これから つかわれます。";
    }
    return word;
  }

  public get subtitleWord2() {
    let word =
      "次の画面から、あなたと文字のことを教えてください。";
    if (this.isHiraganaWord) {
      word =
        "つぎの がめんから、 あなたと もじの ことを おしえてください。";
    }
    return word;
  }

  public get nextPageButtonWord() {
    let word = "次の画面へ進む";
    if (this.isHiraganaWord) {
      word = "つぎの がめんへ すすむ";
    }
    return word;
  }

  public get selectedFontIntroduceWord() {
    let word = "あなたが選んだフォントは";
    if (this.isHiraganaWord) {
      word = "あなたが えらんだ フォントは";
    }
    return word;
  }

  public get selectedFontName() {
    let word = "";
    const fontItem = this.getFontList.find(
      (item) => item.id === this.surveyData.font
    );
    if (fontItem) {
      word = fontItem.name;
    }
    return word;
  }

  public get fontSamplePreviewWord() {
    let word = "あいうえお　アイウエオ 春夏秋冬　ABCDE, abcde. 12345";
    if (this.isHiraganaWord) {
      word = "あいうえお　アイウエオ　春夏秋冬 ABCDE,  abcde . 12345";
    }
    return word;
  }
}
